// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Jost:wght@300;400;500;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@200;300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Dark theme (default) */
  --app-background-color: #000000;
  --background-paper: #1e1e1e;
  --background-card: #141414;
  --background-container: #121212;

  --text-primary: #E6E6E6;
  --text-secondary: rgba(230, 230, 230, 0.7);
  --text-disabled: rgba(230, 230, 230, 0.5);
  --text-subtitle: #94979c;

  --primary-main: #ff9830;
  --primary-light: #ffad59;
  --primary-dark: #b75123;

  --success-main: #00C076;
  --error-main: #FF4A4A;
  --warning-main: #FF9830;
  --info-main: #60A5FA;

  --ui-border: #969696;
  --ui-background-light: #2c2c2c;
  --ui-background-medium: #1e1e1e;
  --ui-background-dark: #121212;
  --ui-card-background: #212121;
  --ui-input-background: #3C3C3C;
  --ui-input-border: #5A5A5A;

  --chart-red: #FF4A4A;
  --chart-green: #00C076;
  --chart-orange: #ffa344;
  --chart-blue: rgba(57, 124, 191, 0.8);
  --chart-gray: #787878;

  --white: #FFFFFF;
  --black: #000000;
  --transparent: #FFFFFF1A;

  --font-family: 'IBM PLEX MONO', monospace;
  --font-family-primary: 'IBM PLEX MONO', monospace;
  --font-family-monospace: 'IBM Plex Mono', monospace;
  --font-size-h1: 1.75rem;
  --font-size-h2: 1.63rem;
  --font-size-h3: 1.5rem;
  --font-size-body1: 0.88rem;
  --font-size-body2: 0.81rem;
  --font-size-small1: 0.75rem;
  --font-size-small2: 0.64rem;

  --spacing-1: 4px;
  --spacing-2: 8px;
  --spacing-3: 12px;
  --spacing-4: 16px;
  --spacing-6: 24px;
  --spacing-8: 32px;

  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;

  --shadow-light: 0 2px 4px rgba(0,0,0,0.1);
  --shadow-medium: 0 4px 8px rgba(0,0,0,0.15);
  --shadow-heavy: 0 8px 16px rgba(0,0,0,0.2);
}

/* Light theme */
[data-theme="light"] {
  --app-background-color: #ffffff;
  --background-paper: #fafafa;
  --background-card: #f5f5f5;
  --background-container: #f5f5f5;

  --text-primary: #000000;
  --text-secondary: rgba(0, 0, 0, 0.7);
  --text-disabled: rgba(0, 0, 0, 0.5);
  --text-subtitle: #61656c;

  --ui-border: #e0e0e0;
  --ui-background-light: #ffffff;
  --ui-background-medium: #fafafa;
  --ui-background-dark: #f5f5f5;
  --ui-card-background: #ffffff;
  --ui-input-background: #ffffff;
  --ui-input-border: #d0d0d0;

  --chart-red: #FF4A4A;
  --chart-green: #00C076;
  --chart-orange: #ffa344;
  --chart-blue: rgba(57, 124, 191, 0.8);
  --chart-gray: #787878;

  --transparent: #0000001A;

  --shadow-light: 0 2px 4px rgba(0,0,0,0.05);
  --shadow-medium: 0 4px 8px rgba(0,0,0,0.08);
  --shadow-heavy: 0 8px 16px rgba(0,0,0,0.12);
}

/* Global body and html styles using theme variables */
body {
  background-color: var(--app-background-color);
  color: var(--text-primary);
  font-family: var(--font-family);
  margin: 0;
  padding: 0;
  height: 100%;
  overflow-x: hidden;
  scrollbar-width: none;
}

html {
  position: relative;
  height: 100%;
}

/* Scrollbar styles using theme variables */
::-webkit-scrollbar-track {
  border-radius: var(--border-radius-medium);
  border: solid 3px transparent;
  background: var(--ui-background-dark);
}

::-webkit-scrollbar-thumb {
  background: var(--ui-background-light);
  border-radius: var(--border-radius-medium);
  border: solid 3px transparent;
  background-clip: content-box;
}

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--ui-background-medium);
}

html::-webkit-scrollbar {
  display: none;
}

/* Global utility classes using theme variables */
.ZSPNcdRNBxDd1GZPDMOg { color: var(--text-primary); }
.tpvMS7vWLmzTAYuUDuTR { color: var(--text-secondary); }
.PozLFj9xncsff2rFKtsD { color: var(--text-disabled); }
.nru5MQFsLy0PrNqtFDjK { color: var(--text-subtitle); }

.x7q5YLMzuv07yf5XomKE { background-color: var(--app-background-color); }
.ovE1nHk1p34rDEZDx04H { background-color: var(--background-paper); }
.c_GEoqHnn9UfjlBu4B0i { background-color: var(--background-card); }
.S16Cb_KkUYRDxN7oreeA { background-color: var(--background-container); }

.DDWMF7ds2YEbdt1FJLfO { background-color: var(--primary-main); }
.hc6uDW7v5DBBDwX2vZZ9 { background-color: var(--success-main); }
.aKZ0FlFZcbzsoYBz2OFd { background-color: var(--error-main); }
.sh37W8TcbF2k3AlfagrF { background-color: var(--warning-main); }
.R08apml4gp0Qa5k0txIB { background-color: var(--info-main); }

.IUxr4Qwbrb3YtExRM7Qi { border-color: var(--primary-main); }
.L63KcnYjwJM37p0eCcyS { border-color: var(--ui-border); }

.cuZuWOoeKeGS8Aj4flsN { border-radius: var(--border-radius-small); }
.IwEgfR_rsQAbxgyV0KM1 { border-radius: var(--border-radius-medium); }
.pg7UvjUN9HL7ZlRDmGhT { border-radius: var(--border-radius-large); }

.bmPPOFwyxp6pDsYhPfaL { box-shadow: var(--shadow-light); }
.il6Ui8LTn73TWOvXzjr2 { box-shadow: var(--shadow-medium); }
.kI0TuW5OpoAgg5LJKyGM { box-shadow: var(--shadow-heavy); }

/* Spacing utilities */
.kB3FcJQ4l6fKHvNwTCQc { padding: var(--spacing-1); }
.DiTUDl4lvF01Ehho_Qtl { padding: var(--spacing-2); }
.ZkqXJ3rsT6s8jtoAhl_X { padding: var(--spacing-3); }
.dTlrU46yD2NyUUbxWRu_ { padding: var(--spacing-4); }
.Ph6MUp4klApDJOCHyGbK { padding: var(--spacing-6); }
.dF7Fv6ePYnEfYreL6IDi { padding: var(--spacing-8); }

.oX8luzr6D3wDE3wXI0kA { margin: var(--spacing-1); }
.qpAu7jQ_tNlZp57S_kxN { margin: var(--spacing-2); }
.OuJWnHsNku01rFcpPGdp { margin: var(--spacing-3); }
.sTJNFjTiTdy4Xj7RM_FI { margin: var(--spacing-4); }
.A3Na8XFomk9S0gE0YgSm { margin: var(--spacing-6); }
.OxRmj2cagYY_BgBvbMFK { margin: var(--spacing-8); }

/* Typography utilities */
.Fj_WezveF5RsuMHvtNn6 { font-size: var(--font-size-h1); }
.COk2YkSoUTGUTohdcmCd { font-size: var(--font-size-h2); }
.Li0UHKkyskYy3luhK3_w { font-size: var(--font-size-h3); }
.Wpk0hhULHNfv24BhjiTX { font-size: var(--font-size-body1); }
.WBM7jQlJ1q5UizqB2rcc { font-size: var(--font-size-body2); }
.oGkFTwtRMc5OBnwrWwkY { font-size: var(--font-size-small1); }
.sS6QQh9Bw__l7g_uShHm { font-size: var(--font-size-small2); }

.hPA9oVcb7SYaKXULtfM7 { font-family: var(--font-family); }

/* Navigation specific styles - removed !important overrides since we're using MUI theme colors directly */
`, "",{"version":3,"sources":["webpack://./css/index.css"],"names":[],"mappings":"AAKA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;;EAE/B,uBAAuB;EACvB,0CAA0C;EAC1C,yCAAyC;EACzC,wBAAwB;;EAExB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;;EAEvB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;;EAEpB,oBAAoB;EACpB,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;;EAE1B,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,qCAAqC;EACrC,qBAAqB;;EAErB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;;EAExB,yCAAyC;EACzC,iDAAiD;EACjD,mDAAmD;EACnD,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;;EAE3B,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;;EAEjB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;;EAE3B,yCAAyC;EACzC,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA,gBAAgB;AAChB;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;;EAE/B,uBAAuB;EACvB,oCAAoC;EACpC,mCAAmC;EACnC,wBAAwB;;EAExB,oBAAoB;EACpB,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;;EAE1B,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,qCAAqC;EACrC,qBAAqB;;EAErB,wBAAwB;;EAExB,0CAA0C;EAC1C,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA,sDAAsD;AACtD;EACE,6CAA6C;EAC7C,0BAA0B;EAC1B,+BAA+B;EAC/B,SAAS;EACT,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA,2CAA2C;AAC3C;EACE,0CAA0C;EAC1C,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;AACf;;AAEA,iDAAiD;AACjD,wBAAgB,0BAA0B,EAAE;AAC5C,wBAAkB,4BAA4B,EAAE;AAChD,wBAAiB,2BAA2B,EAAE;AAC9C,wBAAiB,2BAA2B,EAAE;;AAE9C,wBAAU,6CAA6C,EAAE;AACzD,wBAAY,yCAAyC,EAAE;AACvD,wBAAW,wCAAwC,EAAE;AACrD,wBAAgB,6CAA6C,EAAE;;AAE/D,wBAAc,qCAAqC,EAAE;AACrD,wBAAc,qCAAqC,EAAE;AACrD,wBAAY,mCAAmC,EAAE;AACjD,wBAAc,qCAAqC,EAAE;AACrD,wBAAW,kCAAkC,EAAE;;AAE/C,wBAAkB,iCAAiC,EAAE;AACrD,wBAAa,8BAA8B,EAAE;;AAE7C,wBAAiB,yCAAyC,EAAE;AAC5D,wBAAkB,0CAA0C,EAAE;AAC9D,wBAAiB,yCAAyC,EAAE;;AAE5D,wBAAgB,+BAA+B,EAAE;AACjD,wBAAiB,gCAAgC,EAAE;AACnD,wBAAgB,+BAA+B,EAAE;;AAEjD,sBAAsB;AACtB,wBAAO,yBAAyB,EAAE;AAClC,wBAAO,yBAAyB,EAAE;AAClC,wBAAO,yBAAyB,EAAE;AAClC,wBAAO,yBAAyB,EAAE;AAClC,wBAAO,yBAAyB,EAAE;AAClC,wBAAO,yBAAyB,EAAE;;AAElC,wBAAO,wBAAwB,EAAE;AACjC,wBAAO,wBAAwB,EAAE;AACjC,wBAAO,wBAAwB,EAAE;AACjC,wBAAO,wBAAwB,EAAE;AACjC,wBAAO,wBAAwB,EAAE;AACjC,wBAAO,wBAAwB,EAAE;;AAEjC,yBAAyB;AACzB,wBAAW,8BAA8B,EAAE;AAC3C,wBAAW,8BAA8B,EAAE;AAC3C,wBAAW,8BAA8B,EAAE;AAC3C,wBAAc,iCAAiC,EAAE;AACjD,wBAAc,iCAAiC,EAAE;AACjD,wBAAe,kCAAkC,EAAE;AACnD,wBAAe,kCAAkC,EAAE;;AAEnD,wBAAa,+BAA+B,EAAE;;AAE9C,0GAA0G","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Jost:wght@300;400;500;700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@200;300;400;500;600;700&display=swap');\n\n:root {\n  /* Dark theme (default) */\n  --app-background-color: #000000;\n  --background-paper: #1e1e1e;\n  --background-card: #141414;\n  --background-container: #121212;\n\n  --text-primary: #E6E6E6;\n  --text-secondary: rgba(230, 230, 230, 0.7);\n  --text-disabled: rgba(230, 230, 230, 0.5);\n  --text-subtitle: #94979c;\n\n  --primary-main: #ff9830;\n  --primary-light: #ffad59;\n  --primary-dark: #b75123;\n\n  --success-main: #00C076;\n  --error-main: #FF4A4A;\n  --warning-main: #FF9830;\n  --info-main: #60A5FA;\n\n  --ui-border: #969696;\n  --ui-background-light: #2c2c2c;\n  --ui-background-medium: #1e1e1e;\n  --ui-background-dark: #121212;\n  --ui-card-background: #212121;\n  --ui-input-background: #3C3C3C;\n  --ui-input-border: #5A5A5A;\n\n  --chart-red: #FF4A4A;\n  --chart-green: #00C076;\n  --chart-orange: #ffa344;\n  --chart-blue: rgba(57, 124, 191, 0.8);\n  --chart-gray: #787878;\n\n  --white: #FFFFFF;\n  --black: #000000;\n  --transparent: #FFFFFF1A;\n\n  --font-family: 'IBM PLEX MONO', monospace;\n  --font-family-primary: 'IBM PLEX MONO', monospace;\n  --font-family-monospace: 'IBM Plex Mono', monospace;\n  --font-size-h1: 1.75rem;\n  --font-size-h2: 1.63rem;\n  --font-size-h3: 1.5rem;\n  --font-size-body1: 0.88rem;\n  --font-size-body2: 0.81rem;\n  --font-size-small1: 0.75rem;\n  --font-size-small2: 0.64rem;\n\n  --spacing-1: 4px;\n  --spacing-2: 8px;\n  --spacing-3: 12px;\n  --spacing-4: 16px;\n  --spacing-6: 24px;\n  --spacing-8: 32px;\n\n  --border-radius-small: 4px;\n  --border-radius-medium: 8px;\n  --border-radius-large: 12px;\n\n  --shadow-light: 0 2px 4px rgba(0,0,0,0.1);\n  --shadow-medium: 0 4px 8px rgba(0,0,0,0.15);\n  --shadow-heavy: 0 8px 16px rgba(0,0,0,0.2);\n}\n\n/* Light theme */\n[data-theme=\"light\"] {\n  --app-background-color: #ffffff;\n  --background-paper: #fafafa;\n  --background-card: #f5f5f5;\n  --background-container: #f5f5f5;\n\n  --text-primary: #000000;\n  --text-secondary: rgba(0, 0, 0, 0.7);\n  --text-disabled: rgba(0, 0, 0, 0.5);\n  --text-subtitle: #61656c;\n\n  --ui-border: #e0e0e0;\n  --ui-background-light: #ffffff;\n  --ui-background-medium: #fafafa;\n  --ui-background-dark: #f5f5f5;\n  --ui-card-background: #ffffff;\n  --ui-input-background: #ffffff;\n  --ui-input-border: #d0d0d0;\n\n  --chart-red: #FF4A4A;\n  --chart-green: #00C076;\n  --chart-orange: #ffa344;\n  --chart-blue: rgba(57, 124, 191, 0.8);\n  --chart-gray: #787878;\n\n  --transparent: #0000001A;\n\n  --shadow-light: 0 2px 4px rgba(0,0,0,0.05);\n  --shadow-medium: 0 4px 8px rgba(0,0,0,0.08);\n  --shadow-heavy: 0 8px 16px rgba(0,0,0,0.12);\n}\n\n/* Global body and html styles using theme variables */\nbody {\n  background-color: var(--app-background-color);\n  color: var(--text-primary);\n  font-family: var(--font-family);\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  overflow-x: hidden;\n  scrollbar-width: none;\n}\n\nhtml {\n  position: relative;\n  height: 100%;\n}\n\n/* Scrollbar styles using theme variables */\n::-webkit-scrollbar-track {\n  border-radius: var(--border-radius-medium);\n  border: solid 3px transparent;\n  background: var(--ui-background-dark);\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--ui-background-light);\n  border-radius: var(--border-radius-medium);\n  border: solid 3px transparent;\n  background-clip: content-box;\n}\n\n::-webkit-scrollbar {\n  width: 10px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--ui-background-medium);\n}\n\nhtml::-webkit-scrollbar {\n  display: none;\n}\n\n/* Global utility classes using theme variables */\n.text-primary { color: var(--text-primary); }\n.text-secondary { color: var(--text-secondary); }\n.text-disabled { color: var(--text-disabled); }\n.text-subtitle { color: var(--text-subtitle); }\n\n.bg-app { background-color: var(--app-background-color); }\n.bg-paper { background-color: var(--background-paper); }\n.bg-card { background-color: var(--background-card); }\n.bg-container { background-color: var(--background-container); }\n\n.bg-primary { background-color: var(--primary-main); }\n.bg-success { background-color: var(--success-main); }\n.bg-error { background-color: var(--error-main); }\n.bg-warning { background-color: var(--warning-main); }\n.bg-info { background-color: var(--info-main); }\n\n.border-primary { border-color: var(--primary-main); }\n.border-ui { border-color: var(--ui-border); }\n\n.rounded-small { border-radius: var(--border-radius-small); }\n.rounded-medium { border-radius: var(--border-radius-medium); }\n.rounded-large { border-radius: var(--border-radius-large); }\n\n.shadow-light { box-shadow: var(--shadow-light); }\n.shadow-medium { box-shadow: var(--shadow-medium); }\n.shadow-heavy { box-shadow: var(--shadow-heavy); }\n\n/* Spacing utilities */\n.p-1 { padding: var(--spacing-1); }\n.p-2 { padding: var(--spacing-2); }\n.p-3 { padding: var(--spacing-3); }\n.p-4 { padding: var(--spacing-4); }\n.p-6 { padding: var(--spacing-6); }\n.p-8 { padding: var(--spacing-8); }\n\n.m-1 { margin: var(--spacing-1); }\n.m-2 { margin: var(--spacing-2); }\n.m-3 { margin: var(--spacing-3); }\n.m-4 { margin: var(--spacing-4); }\n.m-6 { margin: var(--spacing-6); }\n.m-8 { margin: var(--spacing-8); }\n\n/* Typography utilities */\n.text-h1 { font-size: var(--font-size-h1); }\n.text-h2 { font-size: var(--font-size-h2); }\n.text-h3 { font-size: var(--font-size-h3); }\n.text-body1 { font-size: var(--font-size-body1); }\n.text-body2 { font-size: var(--font-size-body2); }\n.text-small1 { font-size: var(--font-size-small1); }\n.text-small2 { font-size: var(--font-size-small2); }\n\n.font-mono { font-family: var(--font-family); }\n\n/* Navigation specific styles - removed !important overrides since we're using MUI theme colors directly */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text-primary": `ZSPNcdRNBxDd1GZPDMOg`,
	"text-secondary": `tpvMS7vWLmzTAYuUDuTR`,
	"text-disabled": `PozLFj9xncsff2rFKtsD`,
	"text-subtitle": `nru5MQFsLy0PrNqtFDjK`,
	"bg-app": `x7q5YLMzuv07yf5XomKE`,
	"bg-paper": `ovE1nHk1p34rDEZDx04H`,
	"bg-card": `c_GEoqHnn9UfjlBu4B0i`,
	"bg-container": `S16Cb_KkUYRDxN7oreeA`,
	"bg-primary": `DDWMF7ds2YEbdt1FJLfO`,
	"bg-success": `hc6uDW7v5DBBDwX2vZZ9`,
	"bg-error": `aKZ0FlFZcbzsoYBz2OFd`,
	"bg-warning": `sh37W8TcbF2k3AlfagrF`,
	"bg-info": `R08apml4gp0Qa5k0txIB`,
	"border-primary": `IUxr4Qwbrb3YtExRM7Qi`,
	"border-ui": `L63KcnYjwJM37p0eCcyS`,
	"rounded-small": `cuZuWOoeKeGS8Aj4flsN`,
	"rounded-medium": `IwEgfR_rsQAbxgyV0KM1`,
	"rounded-large": `pg7UvjUN9HL7ZlRDmGhT`,
	"shadow-light": `bmPPOFwyxp6pDsYhPfaL`,
	"shadow-medium": `il6Ui8LTn73TWOvXzjr2`,
	"shadow-heavy": `kI0TuW5OpoAgg5LJKyGM`,
	"p-1": `kB3FcJQ4l6fKHvNwTCQc`,
	"p-2": `DiTUDl4lvF01Ehho_Qtl`,
	"p-3": `ZkqXJ3rsT6s8jtoAhl_X`,
	"p-4": `dTlrU46yD2NyUUbxWRu_`,
	"p-6": `Ph6MUp4klApDJOCHyGbK`,
	"p-8": `dF7Fv6ePYnEfYreL6IDi`,
	"m-1": `oX8luzr6D3wDE3wXI0kA`,
	"m-2": `qpAu7jQ_tNlZp57S_kxN`,
	"m-3": `OuJWnHsNku01rFcpPGdp`,
	"m-4": `sTJNFjTiTdy4Xj7RM_FI`,
	"m-6": `A3Na8XFomk9S0gE0YgSm`,
	"m-8": `OxRmj2cagYY_BgBvbMFK`,
	"text-h1": `Fj_WezveF5RsuMHvtNn6`,
	"text-h2": `COk2YkSoUTGUTohdcmCd`,
	"text-h3": `Li0UHKkyskYy3luhK3_w`,
	"text-body1": `Wpk0hhULHNfv24BhjiTX`,
	"text-body2": `WBM7jQlJ1q5UizqB2rcc`,
	"text-small1": `oGkFTwtRMc5OBnwrWwkY`,
	"text-small2": `sS6QQh9Bw__l7g_uShHm`,
	"font-mono": `hPA9oVcb7SYaKXULtfM7`
};
export default ___CSS_LOADER_EXPORT___;
